<section class="card-details-container">
    <section class="header-container">
        <section class="card-detail-title">
            <figure *ngIf="srcImg" class="icon-detail">
              <img [ngSrc]="srcImg | staticServe" width="20" height="20" />
            </figure>
            <label *ngIf="title" class="title-detail">{{ title }}</label>
        </section>

        <figure *ngIf="srcButton" class="button-icon" (click)="onClick()">
            <img [ngSrc]="srcButton | staticServe" width="16" height="16" />
        </figure>
    </section>
    
    <ng-content></ng-content>
  </section>